import { FormScene } from 'constants/FormScene';
import { MeetingModeEnum } from 'interfaces/MeetingMode';

export const Routes = {
  dashboard: '/',
  formAboutUs: '/form-about-us/:formId/:managed?/:meetingMode?',
  getFormAboutUs: (formId: string, managed: boolean, meetingMode?: MeetingModeEnum): string => {
    return `/form-about-us/${formId}/${managed ? 'managed' : 'no'}${meetingMode ? `/${meetingMode}` : ``}`;
  },
  formDetail: '/form/:formId/:managed?/:meetingMode?',
  formAgreement: '/form-agreement/:formId/:managed?/:meetingMode?',
  formQuestions: '/form-questions/:formId/:managed?/:meetingMode?',
  // formPresentation: '/form-presentation/:formId/:managed?/:meetingMode?',
  formPayment: '/form-payment-data/:formId/:managed?/:meetingMode?',

  formSummary: '/form-summary/:formId/:managed?/:meetingMode?',
  getFormSummary: (formId: string, managed: boolean, meetingMode?: MeetingModeEnum): string => {
    return `/form-summary/${formId}/${managed ? 'managed' : 'no'}${meetingMode ? `/${meetingMode}` : ``}`;
  },

  formTransmitReport: '/form-transmit-report/:formId/:managed?/:meetingMode?',
  getFormTransmitReport: (formId: string, managed: boolean, meetingMode?: MeetingModeEnum): string => {
    return `/form-transmit-report/${formId}/${managed ? 'managed' : 'no'}${meetingMode ? `/${meetingMode}` : ``}`;
  },

  formRejected: '/form-rejected/:formId/:managed?/:meetingMode?',

  formStarter: '/form-starter/:formId/:managed?/:meetingMode?',
  getFormStarter: (formId: string, managed: boolean, meetingMode?: MeetingModeEnum): string => {
    return `/form-starter/${formId}/${managed ? 'managed' : 'no'}${meetingMode ? `/${meetingMode}` : ``}`;
  },

  formUploadIdentityCard: '/form-upload-identity-card/:formId/:managed?/:meetingMode?',

  getLink: (link: string, params: any): string => {
    const newLink = Object.keys(params).reduce((acc: string, key: string) => {
      return acc.replace(`:${key}?`, params[key] || '').replace(`:${key}`, params[key] || '');
    }, link);
    return newLink;
  },

  getLinkByScene: (scene: string, params: any): string | undefined => {
    switch (scene) {
      case FormScene.Starter:
        return Routes.getLink(Routes.formStarter, params);
      case FormScene.Agreement:
        return Routes.getLink(Routes.formAgreement, params);
      case FormScene.Detail:
        return Routes.getLink(Routes.formDetail, params);
      case FormScene.Summary:
        return Routes.getLink(Routes.formSummary, params);
      case FormScene.TransmitReport:
        return Routes.getLink(Routes.formTransmitReport, params);
      default:
        return undefined;
    }
  },
};
